
export class StudentAssignmentSearchQuery {

    public static fromQueryString(queryString: string) {
        const studentAssignmentSearchQuery = new StudentAssignmentSearchQuery();

        if (queryString.indexOf("?") === 0) {
            queryString = queryString.slice(1);
        }

        return queryString.split("&").reduce((acc: StudentAssignmentSearchQuery, queryKeyVal: string) => {

            const parts = queryKeyVal.split("=");
            const key = parts[0];
            let val: any = parts[1];

            if (key.toLowerCase() === "userid") {
                acc.userId = val;
                return acc;
            }

            if (key.toLowerCase() === "onlycurrent") {                              
                acc.onlyCurrent = (val === "false") ? false : true              
                return acc;
            }

            acc[key] = val;

            return acc;

        }, studentAssignmentSearchQuery);

    }
    

    [key: string]: any;

    userId?: string;
    onlyCurrent?: boolean;
}
